//import firebase from "firebase";
import { baseUrl } from "../../config/app.config";
import axios from "axios";

//Get Child nodes
export const GetChildnodes = async file => {
  let result;
  try {
    result = await axios({
      method: "get",
      url: baseUrl + "/api/Attachments?prefix=" + file.id
    });
  } catch (e) {
    result = e.response;
  }
  return result;
};
